// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

/* istanbul ignore next */
import type { VoiceFocusPaths } from '../../libs/voicefocus/types';

// Barrelizer re-export, assemble!
export default VoiceFocusPaths;
